import { render, staticRenderFns } from "./menuData.vue?vue&type=template&id=79be9831"
import script from "./menuData.vue?vue&type=script&lang=js"
export * from "./menuData.vue?vue&type=script&lang=js"
import style0 from "./menuData.vue?vue&type=style&index=0&id=79be9831&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports